import clsx from 'clsx';
import { Loader2Icon } from 'lucide-react';
import type React from 'react';
import { useEffect, useState } from 'react';

const APPEAR_TIMEOUT = 500;

export const Loading: React.FC<{
    className?: string;
    children?: React.ReactNode;
    renderTimeoutContent?: () => React.ReactNode;
    label?: string;
    timeout?: number;
    timeoutMessage?: string;
    onTimeout?: () => void;
}> = ({
    className,
    children,
    label,
    timeout = 10000,
    timeoutMessage = 'Načítání trvá déle než obvykle, zkuste prosím obnovit stránku.',
    renderTimeoutContent,
    onTimeout
}) => {
    const [ timedOut, setTimedOut ] = useState(false);
    const [ show, setShow ] = useState(false);

    useEffect(() => {
        if (timeout) {
            const timer = setTimeout(() => {
                setTimedOut(true);
                onTimeout?.();
            }, timeout);

            return () => {
                clearTimeout(timer);
            };
        }
    }, [ timeout ]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, APPEAR_TIMEOUT);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <div className={clsx(
            'flex flex-col items-center justify-center gap-4 transition-opacity duration-300',
            show ? 'opacity-100' : 'opacity-0',
            className
        )}>
            <div className='animate-spin will-change-transform text-gray-400'><Loader2Icon size={32} /></div>
            <div className='flex flex-col items-center justify-center gap-2 empty:hidden'>
                {label && <div className='text-gray-600'>{label}</div>}
                {timedOut && timeoutMessage && <div className='text-sm text-red-900'>{timeoutMessage}</div>}
                {children}
                {timedOut && renderTimeoutContent && renderTimeoutContent()}
            </div>
        </div>
    );
};
